import _ from 'lodash';
import moment from 'moment';
import numeral from 'numeral';

import api from '../../api';

import { SummarySpreadsheet } from '../../../spreadsheets/summary-spreadsheet';

export const converter = (() => {
    let _visible = false;
    let _template = null;
    let _dialog = null;

    const _getTitle = name => {
        switch (name) {
            case 'Dealerships':
            case 'Competitors':
            case 'StoreInactive':
                return ['Id', 'Grupo', 'Nome', 'Bandeira', 'Contato', 'Endereco', 'Bairro', 'Cidade', 'UF'];
            case 'Points':
        }
    };

    const _onClose = () => {
        _visible = false;
        _dialog.destroy();
        _template.remove();
    };

    const _createDialog = (type) => {
        if (_visible) return;

        _visible = true;
        const isSummary = type === 'summary';

        _template = $(
            `<div>
                <div style="margin: -4px 26px -4px -4px;">
                    <a class="btn btn-block btn-option" ${ isSummary ? '' : 'style="display:none"' } data-format=";">excel (xslx)</a>
                    <a class="btn btn-block btn-option" ${ isSummary ? 'style="display:none"' : '' } data-format=";">csv (pt-BR)</a>
                    <a class="btn btn-block btn-option" ${ isSummary ? 'style="display:none"' : '' } data-format=",">csv (us-US)</a>
                    <a class="btn btn-block btn-default" >Fechar</a>
                </div>
            </div>`
        );

        _dialog = $(_template).kendoWindow({
            width: '240px',
            resizable: false,
            draggable: false,
            visible: false,
            title: false,
            appendTo: 'body',
            close: _onClose
        }).data('kendoWindow');

        _dialog.center().open();
    };

    const _generateCSV = (data, type, separator) => {
        let output = '';
        let line = '';
        let titles = [];

        return new Promise((resolve, reject) => {
            switch (type) {
                case 'Dealerships':
                case 'Competitors':
                case 'StoreInactive':
                case 'Points':
                    const extractValues = (f, res) => {
                        line = '';
                        _.forEach(res, values =>
                            _.forEach(values, (value, key) => {
                                f.properties[key.toCapitalCase()] = value;
                            })
                        );
                        _.forEach(titles, t => {
                            const text = f.properties[t];
                            line += `"${String(text || '').toASCII()}"${separator}`;
                        });

                        output += `${line}\r\n`;
                    };

                    titles = _getTitle(type);

                    // get the title of table
                    _.forEach(titles, title => {
                        line += `"${String(title || '').toASCII()}"${separator}`;
                    });
                    // create a new line
                    output += `${line}\r\n`;

                    // get data for the rows
                    const queue = _.map(data, f => api.store.get(f.properties.Id, type).catch((err) => err));
                    Promise.all(queue).then(res => {
                        _.forEach(res, (r, i) => extractValues(data[i], r));
                        resolve(output);
                    });
                    break;

                case 'summary':
                case 'store':
                    const _processCharts = values => {
                        let table = [];
                        if (_.isFunction(values.convertToTable)) {
                            table = values.convertToTable();
                        } else if (values.dataSource) {
                            table = _.reduce(values.dataSource.data, (acc, val) => {
                                acc.push(_.map(acc[0], v => val[v]));
                                return acc;
                            }, [_.map(values.columns, v => v.field)]);
                        }

                        _.forEach(table, row => {
                            line = '';
                            _.forEach(row, column => {
                                const value = Number(column) > 0 ? numeral(column).format('0,0[.]00') : String(column || '').toASCII();
                                line += `"${value}"${separator}`;
                            });

                            if (line) { output += `${line}\r\n`; }
                        });
                    };

                    const _processGrid = values => {
                        line = '';
                        _.forEach(values.columns, column => {
                            const value = String(column.title || column.field || '').toASCII();
                            line += `"${value}"${separator}`;
                        });

                        if (line) { output += `${line}\r\n`; }

                        _.forEach(values.dataSource, row => {
                            line = '';
                            _.forEach(values.columns, column => {
                                const value = Number(row[column.field]) > 0 ? numeral(row[column.field]).format('0,0[.]00') : String(row[column.field] || '').toASCII();
                                line += `"${value}"${separator}`;
                            });

                            if (line) { output += `${line}\r\n`; }
                        });
                    };

                    const _processValues = (values, inline) => {
                        if (values[0] && values[0].title) {
                            _.forEach(values, (v, i) => {
                                if (inline && i === 0) {
                                    output += `""${separator}`;
                                    _.forEach(v.values, item => {
                                        output += `"${item.label ? item.label : ''}"${separator}`;
                                    });
                                    output += '\r\n';
                                }

                                if (v.title) {
                                    if (!inline) output += '\r\n';
                                    output += `"${String(v.title ? v.title : '').toASCII()}"`;
                                    if (!inline) output += '\r\n';
                                }

                                if (v.chart) {
                                    _processCharts(v.chart);
                                }

                                if (v.grid) {
                                    _processGrid(v.grid);
                                }

                                if (v.values && v.values.length > 0) {
                                    _processValues(v.values, true);
                                }
                            });
                        } else {
                            if (inline) output += `${separator}`;

                            _.forEach(values, v => {
                                if (!v) return;
                                if (inline) {
                                    output += `"${String(v.value ? v.value : '').toASCII()}"${separator}`;
                                } else {
                                    output += `"${String(v.label ? v.label : '').toASCII()}"${separator}"${v.value ? v.value : ''}"\r\n`;
                                }
                            });

                            if (inline) output += '\r\n';
                        }
                    };

                    _.forEach(data, v => {
                        if (!v) return;

                        if (v.title) {
                            output += `\r\n"${String(v.title ? v.title : '').toASCII()}"\r\n`;
                        }

                        if (v.chart) {
                            _processCharts(v.chart);
                        } else if (v.grid) {
                            _processGrid(v.grid);
                        } else if (v.values) {
                            _processValues(v.values);
                        }
                    });

                    resolve(output);
                    break;

                case 'charts':
                    // get data for the rows
                    _.forEach(data, row => {
                        line = '';
                        _.forEach(row, col => {
                            line += `"${_.isNumber(col) ? numeral(col).format('0,0[.]00') : String(col).toASCII()}"${separator}`;
                        });
                        output += line + '\r\n';
                    });

                    resolve(output);
                    break;
            }
        });
    };

    const _showDialog = options => {
        const _download = e => {
            e.preventDefault();

            if (e.target.innerText.toLowerCase().indexOf('excel') > -1) {
                new SummarySpreadsheet({ ...options, type: options.idType, name: options.summaryName });
                _dialog.close();
                return;
            }

            _generateCSV(options.data, options.type, $(e.target).data('format')).then((csv) => {
                kendo.saveAs({
                    dataURI: `data:text/csv;charset=utf-8;base64,${btoa(csv)}`,
                    fileName: options.filename
                });
                _dialog.close();
            });
        };

        const _close = e => {
            e.preventDefault();
            _dialog.close();
        };

        _createDialog(options.type);

        $(_template).find('.btn-option').on('click', _download);
        $(_template).find('.btn-default').on('click', _close);
    };

    const csv = options => {
        const { name } = options;
        if (name.includes("Summary")) {
            options.filename = `${name}.csv`;
            if (options.button) {
                $(options.button).on('click', e => {
                    e.stopPropagation();
                    _showDialog(options);
                });
            } else {
                _showDialog(options);
            }
        } else {
            //TO DO: Foi acordado que mais na frente ver a refatoração desse cara com o motivo de esta passando uma data novamente

            options.filename = `${name}.csv`;
            if (options.button) {
                $(options.button).on('click', e => {
                    e.stopPropagation();
                    _showDialog(options);
                });
            } else {
                _showDialog(options);
            }
        }
    };

    return {
        csv
    };
})();

export default converter;



// WEBPACK FOOTER //
// ./src/scripts/core/converter/index.js